var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.b(),_vm.className],style:(_vm.styleSizeName),on:{"click":_vm.handleClick}},[_c('img',{class:_vm.b({'rotate': _vm.rotate}),style:([_vm.styleChartName,_vm.styleImgName]),attrs:{"src":_vm.dataChart.value,"draggable":"false"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }